// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__QcVS6","errorLogs":"styles_errorLogs__WuACh"};